import Big from 'big.js'

import { InvoiceFormValues } from 'app/components/InvoiceForm/schema'
import { Control, UseFormWatch } from 'react-hook-form'
import { ProductField } from 'ui/forms/fields/ProductField'
import { NumberInputField } from 'ui/forms/fields/NumberInputField'
import formatAmount from 'helpers/formatAmount'
import { Button } from 'antd'

interface InvoiceLineFieldsProps {
  control: Control<InvoiceFormValues>
  index: number
  onRemove: () => void
  watch: UseFormWatch<InvoiceFormValues>
}
const InvoiceLineFields = ({
  control,
  index,
  onRemove,
  watch,
}: InvoiceLineFieldsProps) => {
  const { product, quantity } = watch(`invoice_lines.${index}`)

  const totalPrice = product?.unit_price
    ? Big(Number(product.unit_price)).times(quantity).toNumber()
    : null

  const totalTax = product?.unit_tax
    ? Big(Number(product.unit_tax)).times(quantity).toNumber()
    : null

  return (
    <>
      <td className="p-2 product-column">
        <ProductField
          control={control}
          name={`invoice_lines.${index}.product`}
        />
      </td>
      <td>{product?.unit ?? '-'}</td>
      <td>
        {product?.unit_price ? formatAmount(Number(product?.unit_price)) : '-'}
      </td>
      <td>{product?.vat_rate ? `${product?.vat_rate}%` : '-'}</td>
      <td>
        {product?.unit_tax ? formatAmount(Number(product?.unit_tax)) : '-'}
      </td>
      <td className="p-2">
        <NumberInputField
          control={control}
          name={`invoice_lines.${index}.quantity`}
        />
      </td>
      <td>{totalPrice || totalPrice === 0 ? formatAmount(totalPrice) : '-'}</td>
      <td>{totalTax || totalTax === 0 ? formatAmount(totalTax) : '-'}</td>
      <td className="p-2">
        <Button
          onClick={() => {
            onRemove()
          }}
          color="danger"
          variant="solid"
        >
          Remove
        </Button>
      </td>
    </>
  )
}

export default InvoiceLineFields
